module.exports = __webpack_public_path__ + "img/inter-v11-latin-regular.f5089d8.svg";